import { inject, injectable } from "inversify";
import { computed, makeObservable } from "mobx";
import { fromPromise } from "mobx-utils";
import { TuvisSettingsDataLayerSymbol } from "./TuvisSettingsDataLayerSymbol";
import type { ITuvisSettingsDataLayer } from "../types/ITuvisSettingsDataLayer";

@injectable()
export class TuvisSettingsStore {
  constructor(@inject(TuvisSettingsDataLayerSymbol) private tuvisSettingsDataLayer: ITuvisSettingsDataLayer) {
    makeObservable(this, {
      init: computed,
    });
  }

  get init() {
    return fromPromise(this.tuvisSettingsDataLayer.init());
  }
}
